module.exports = __webpack_public_path__ + "static/media/Hoist_ios_5_preview.51f7d612.jpg";